// Shared tokens + helpers for the shifts module.
// Date/time formatting lives in lib/shop-time.js (Melbourne-local, DST-aware) —
// shared with the jobs module, which needs the exact same conversion.
export { formatDateTime, formatTime, formatDateShort, toInputValue, fromInputValue } from '../../lib/shop-time.js';

export const SLATE = '#7C8FA6';

export const formatHours = (h) => {
  if (h == null) return '—';
  const sign = h < 0 ? '-' : '';
  const abs = Math.abs(h);
  const hrs = Math.floor(abs);
  const mins = Math.round((abs - hrs) * 60);
  return `${sign}${hrs}h ${String(mins).padStart(2, '0')}m`;
};
